<template>
    <lay-row space="10">
      <lay-col md="24">
        <lay-panel> 
          <lay-table :page="page" :height="'100%'" :columns="columns" :loading="loading" :data-source="dataSource"
            v-model:selected-keys="selectedKeys" @change="change" @sortChange="sortChange">   
            <template #state="{ row }">
              <div v-if="row.state==1">正常</div>
              <div v-else-if="row.state==2" style="color:red ;">用户退单</div> 
            </template>


          </lay-table> 
        </lay-panel>
  
      </lay-col>
  
    </lay-row>
 
  </template>
  
  <script lang="ts" setup>
  import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allOrderAgentDetails} from '../../api'
  
 
  const searchSelection = ref("")
  const loading = ref(false);
  
  const dataSource = ref([]);
  
  const selectedKeys = ref([]);
  
  const page = reactive({ current: 1, limit: 10, total: 0 });

  const search = reactive({
    key: searchSelection,
  })
  
  const columns = ref([
   
    { title: "订单号", key: "orderId", align: "center"}, 
    { title: "状态", key: "state", align: "center" , customSlot: "state"}, 
    { title: "总收益", key: "generalAgentIncome", align: "center" },  
    { title: "代理收益", key: "agencyIncome", align: "center" },   
    { title: "代理比例", key: "agentProportion", align: "center" }, 
    { title: "平台", key: "platformId", align: "center" },  
    { title: "注册时间", key: "addTime", align: "center" }, 
  ]);
  
  const getAllOrderDetails = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit, "key": search.key };
    allOrderAgentDetails(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllOrderDetails();
  
  const change = (page: any) => {
    getAllOrderDetails();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
   

  </script>
  
  <style scoped>
  </style>